export default {
  scheduled_order: 'Scheduled Order',
  show_more: 'Show more',
  show_less: 'Show less',
  schedule_order: 'Schedule order',
};
